import { type Reducer } from 'redux';

import {
  type UpdateBatchSeen,
  type UpdateStudentTalkTime,
  type UpdateTeacherTalkTime,
  ACTIONS,
} from '@~/actions/talk-meter';

export interface TalkMeterState {
  teacherTalkTime: number;
  studentTalkTime: number;
  lastBatchReceivedNo: number;
  batchSeen: number;
  canDisplayBatch: boolean;
}
interface InitialState {
  [teacherClassroomId: string]: TalkMeterState;
}

const initialState: InitialState = {
  teacherClassroomId: {
    teacherTalkTime: 0,
    studentTalkTime: 0,
    lastBatchReceivedNo: 0,
    batchSeen: 0,
    canDisplayBatch: false,
  },
};

const createInitialTalkMeterState = (): TalkMeterState => ({
  teacherTalkTime: 0,
  studentTalkTime: 0,
  lastBatchReceivedNo: 0,
  batchSeen: 0,
  canDisplayBatch: false,
});

type TReducer = Reducer<
  InitialState,
  | ReturnType<UpdateStudentTalkTime>
  | ReturnType<UpdateTeacherTalkTime>
  | ReturnType<UpdateBatchSeen>
>;

const talkMeterReducer: TReducer = (state = initialState, { type, payload }) => {
  if (type === ACTIONS.STUDENT_TALK_TIME_UPDATED) {
    const {
      student_speech_time: studentCurrTalktime = 0,
      teacher_classroom_id: teacherClassRoomId,
    } = payload;
    const currClassState = state[teacherClassRoomId] || createInitialTalkMeterState();

    return {
      [teacherClassRoomId]: {
        ...currClassState,
        studentTalkTime: currClassState.studentTalkTime + studentCurrTalktime,
      },
    };
  }

  if (type === ACTIONS.TEACHER_TALK_TIME_UPDTAED) {
    const {
      teacher_speech_time: teacherTalkTillNow = 0,
      teacher_classroom_id: teacherClassRoomId,
      batch_no: batchNo,
    } = payload;
    const currClassState = state[teacherClassRoomId] || createInitialTalkMeterState();

    return {
      [teacherClassRoomId]: {
        ...currClassState,
        teacherTalkTime: teacherTalkTillNow,
        lastBatchReceivedNo: batchNo,
      },
    };
  }

  if (type === ACTIONS.UPDATE_BATCH_SEEN) {
    const { teacher_classroom_id: teacherClassRoomId, batch_no: batchNo } = payload;
    const currClassState = state[teacherClassRoomId] || createInitialTalkMeterState();

    return {
      [teacherClassRoomId]: {
        ...currClassState,
        batchSeen: batchNo,
      },
    };
  }

  if (type === ACTIONS.CAN_DISPLAY_TM) {
    const { teacher_classroom_id: teacherClassRoomId, canDisplay } = payload;
    const currClassState = state[teacherClassRoomId] || createInitialTalkMeterState();

    return {
      [teacherClassRoomId]: {
        ...currClassState,
        canDisplayBatch: canDisplay,
      },
    };
  }

  return state;
};

export default talkMeterReducer;
